import { ReactNode, useEffect, useRef } from 'react';

const SETTLE_MS = 3000;

/**
 * Кт1: the open report is drawn below the board or list; on open the window scrolls so its top is at the top edge.
 * The report is still loading and grows, so the page has nowhere to scroll yet: scroll again while it grows (first seconds),
 * and stop as soon as the person scrolls. Closing does not scroll.
 */
export default function RevealOnOpen({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const reveal = (behavior: ScrollBehavior) => el.scrollIntoView?.({ block: 'start', behavior });
    reveal('smooth');
    const stop = () => observer?.disconnect();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(() => reveal('auto'));
    observer?.observe(el);
    const timer = setTimeout(stop, SETTLE_MS);
    const events = ['wheel', 'touchstart', 'keydown'] as const;
    for (const name of events) window.addEventListener(name, stop, { passive: true, once: true });
    return () => {
      clearTimeout(timer);
      stop();
      for (const name of events) window.removeEventListener(name, stop);
    };
  }, []);
  return (
    <div ref={ref} className="bug-open-detail">
      {children}
    </div>
  );
}
